import React, { ReactNode } from 'react';
import { makeStyles, Checkbox, FormControlLabel } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const styles = makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    }
}));

export interface CheckableTreeItemNode {
    label: ReactNode,
    checked?: boolean,
    indeterminate?: boolean,
    format_wording?: boolean
}

interface CheckableTreeItemProps {
    node: CheckableTreeItemNode,
    onChecked?: (evt: React.MouseEvent, node: CheckableTreeItemNode) => void,
    checkable?: boolean,
    disabled?: boolean,
}

export function CheckableTreeItem(props: CheckableTreeItemProps) {
    const classes = styles();
    const checkable = props.checkable ?? true;
    const [t] = useTranslation<'common'>();
    return (
        <div className={classes.root}>
            <FormControlLabel disabled={props.disabled} label={props.node.format_wording ? t(`apis.rapport.filtres.${props.node.label}`) : props.node.label}
                control={
                    checkable ? <Checkbox color="primary"
                        checked={props.node.checked ?? false}
                        onClick={(evt) => props.onChecked && props.onChecked(evt, props.node)}
                        indeterminate={props.node.indeterminate ?? false}
                        disabled={props.disabled}
                    /> : <span style={{ width: 30, height: 42, display: "inline-block" }}></span>
                }
            />
        </div>
    )
}
